import type {
	ChartSecuritiesTct,
	ChartSecurityTct,
	SecuritySummary,
} from '@dealstack/shared/lib/generated';
import type { CapChartSecurityGroup } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/capChartSecurities.types.ts';

const flattenSecurityTypes = (securities: ChartSecurityTct): SecuritySummary[] =>
	Object.values(securities).flatMap((list) => list ?? []);

export const flattenChartSecurities = (data?: ChartSecuritiesTct[]): SecuritySummary[] =>
	(data ?? []).flatMap((item) => flattenSecurityTypes(item.securities));

/** One group per issuing entity, dropping issuers with no securities. */
export const groupChartSecurities = (data: ChartSecuritiesTct[]): CapChartSecurityGroup[] =>
	data
		.map(({ person, securities }, index) => ({
			key: person?.id ?? `no-issuer-${index}`,
			issuerName: person?.displayName,
			securities: flattenSecurityTypes(securities),
		}))
		.filter(({ securities }) => securities.length > 0);

/** Every listed security is selected unless excluded; if all of them are excluded, all are selected. */
export const resolveSecuritySelection = (
	securityIds: string[],
	excludedIds: ReadonlySet<string>
): Map<string, boolean> => {
	const isAllExcluded = securityIds.length > 0 && securityIds.every((id) => excludedIds.has(id));
	return new Map(securityIds.map((id) => [id, isAllExcluded || !excludedIds.has(id)]));
};
